import React from 'react';

const BlogPostList = ({ blogPosts, onEdit, onDelete }) => {
  if (blogPosts.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <p className="font-roboto text-lg text-gray-600">No blog posts yet. Create your first post!</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {blogPosts.map((post) => (
        <div
          key={post.id}
          className="bg-white rounded-lg shadow-md p-6"
          data-testid={`admin-post-${post.id}`}
        >
          <div className="flex justify-between items-start">
            <div className="flex-1">
              {post.image_url && (
                <img src={post.image_url} alt={post.title} className="w-32 h-32 object-cover rounded mb-4" />
              )}
              <div className="flex items-center gap-2 mb-2">
                <span className="inline-block bg-[#aaae10] text-white px-3 py-1 rounded-full font-roboto text-xs font-medium">
                  {post.category}
                </span>
                {!post.published && (
                  <span className="inline-block bg-gray-400 text-white px-3 py-1 rounded-full font-roboto text-xs font-medium">
                    Draft
                  </span>
                )}
                <span className="inline-block bg-blue-500 text-white px-3 py-1 rounded-full font-roboto text-xs font-medium">
                  {post.views || 0} views
                </span>
              </div>
              <h3 className="font-rubik text-xl font-bold text-[#646464] uppercase mb-2">
                {post.title}
              </h3>
              <p className="font-roboto text-sm text-gray-600 mb-2">{post.date}</p>
              <p className="font-roboto text-base text-gray-700">{post.excerpt}</p>
            </div>
            <div className="flex gap-2 ml-4">
              <button
                onClick={() => onEdit(post)}
                className="btn-secondary text-sm"
                data-testid={`edit-post-${post.id}`}
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(post.id)}
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded font-rubik text-sm transition-colors"
                data-testid={`delete-post-${post.id}`}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogPostList;
